import { getUserInfo, login } from '@/api/sys'
import { getItem, removeAllItem, setItem } from '@/utils/storage'
import { TOKEN } from '@/constant'
import { setTimeStamp } from '@/utils/auth'
import router, { resetRouter } from '@/router'
import { enterSchool } from '@/api/school.js'

export default {
    namespaced: true,
    state: () => ({
        token: getItem(TOKEN) || '',
        userInfo: {}
    }),
    mutations: {
        setToken(state, token) {
            state.token = token
            setItem(TOKEN, token)
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo
        }
    },
    actions: {
        /**
         * 登录请求的动作
         * @param {*} context
         * @param {*} userInfo
         * @returns
         */
        login(context, userInfo) {
            const { username, password, code } = userInfo
            return new Promise((resolve, reject) => {
                login({
                    username,
                    password,
                    code
                })
                    .then((data) => {
                        this.commit('user/setUserInfo', data)
                        this.commit('user/setToken', data.token)
                        // 保存登录时间
                        setTimeStamp()
                        setItem('subsystem', '')
                        router.replace('/workbench').then(() => {
                            window.location.reload()
                            resolve()
                        })
                        resolve()
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        switchUser(context, userInfo) {
            return new Promise((resolve, reject) => {
                enterSchool(userInfo)
                    .then(async (data) => {
                        console.log('🚀 ~ data:', data)
                        this.commit('user/setUserInfo', data)
                        this.commit('user/setToken', data.token)
                        // 保存登录时间
                        setTimeStamp()

                        setItem('subsystem', '')
                        router.replace('/workbench').then(() => {
                            window.location.reload()
                            resolve()
                        })
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        saveToken(state, data) {
            this.commit('user/setToken', data)
        },

        /**
         * 获取用户信息
         * @param {*} context
         * @returns
         */
        async getUserInfo(context) {
            const res = await getUserInfo()
            this.commit('user/setUserInfo', res)
            return res
        },

        // 退出登录
        logout() {
            // 退出清理路由
            resetRouter()
            this.commit('user/setToken', null)
            this.commit('app/clearTagsView')
            removeAllItem()
            this.commit('user/setUserInfo', {})
            router.replace('/login').then()
            location.reload()
        }
    }
}
